/* eslint-disable */
// THIS FILE IS GENERATED. DO NOT EDIT. Edits should be made in 'header-logo-link.scss' instead.
import { css } from 'lit';
export default css `:host([slot^=header-logo]){margin-top:0!important}@media (max-width:1199.98px){:host([slot^=header-logo]) a{display:flex;padding:0}}`;
//# sourceMappingURL=header-logo-link.scss.js.map